module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./AccountView.js"));
	}, "AccountView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AccountView!./src/pages/Shop/Member/Personal/Account/AccountView.js
// module id = 978
// module chunks = 431